import { baixarArquivo } from './appNativo';

function escapeCell(value) {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (/[";\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function exportToCsv(filename, columns, rows) {
  const header = columns.map((c) => escapeCell(c.label)).join(';');
  const body = rows
    .map((row) => columns.map((c) => escapeCell(c.value(row))).join(';'))
    .join('\n');

  const csv = `\uFEFF${header}\n${body}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

  // Dentro do app do Fio a âncora com `download` não faz nada; o helper cuida
  // dos dois casos. Ver src/helpers/appNativo.js.
  return baixarArquivo(filename.endsWith('.csv') ? filename : `${filename}.csv`, blob);
}
